import { Injectable } from '@angular/core';
import { User } from '@mitel/cloudlink-sdk';
import { AppInjector } from '../../app-injector';
import { ProductLicense, ProductLicenseItemServiceInf } from '../interfaces/product-licenses-interfaces';
import { DisableTelephonyAccountAccessStatement } from '../constants/productPolicies';
import { AdminService } from './admin.service';
import { IntegPolicyService } from './integ-policy.service';
import { IntegSharedCCService } from './integ-shared-cc.service';

@Injectable({
  providedIn: 'root'
})
export class UserProdTelephonyService implements ProductLicenseItemServiceInf {
  private adminService: AdminService;
  private policyService: IntegPolicyService;
  private ccSharedService:IntegSharedCCService;
  constructor() { 
  }

  initializeServices()
	{
    if ( !this.adminService )
      this.adminService = AppInjector.injector.get(AdminService);
    if ( !this.policyService )
			this.policyService = AppInjector.injector.get(IntegPolicyService);
    if( !this.ccSharedService)
      this.ccSharedService = AppInjector.injector.get(IntegSharedCCService);
  }

  canBeAdded(user: User, product: ProductLicense, isSubComponent?: boolean): Promise<boolean> {
    return Promise.resolve(true);
  }

  hasRequiredAccountIntegrations( user: User, accountIntegrations: string[] ):  Promise<boolean>
  {
    return Promise.resolve( accountIntegrations.includes('MitelOne') );
  }

  getConfigurationDialog(setupComplete?: boolean): Promise<any> {
    return Promise.resolve(undefined);
  }

  isSetupComplete(user: User): Promise<boolean> {
    return Promise.resolve(true);
  }

  handleProductStateChange(user: User, state: boolean, isSubComponent?: boolean): Promise<any> {
    this.initializeServices();
    console.log('handling state change of telephony product for the user');
    if (isSubComponent) {
      return this.adminService.getUserWithoutFrills(user.userId).then( newUser => {
          if ( state == true )
          {
            // remove the user policy statement
            if ( newUser['policyId'] === undefined ) // nothing to remove
            {
              return Promise.resolve(true);
            }
            return this.adminService.getPolicy(user.accountId, newUser['policyId']).then( policy => {
                console.log("Here are the user policies", policy);
                const foundPolicy = policy.statements.find(stmt => {
                  return stmt.statementId === DisableTelephonyAccountAccessStatement.statementId;
                });
                if ( foundPolicy )
                {
                  return this.policyService.removeStatementFromPolicy(newUser, policy, DisableTelephonyAccountAccessStatement);
                }
                else
                  return Promise.resolve(true);
            });
    
          }
          else
          {
            // add the policy statement for the user
            return this.policyService.addStatementToPolicy( newUser, DisableTelephonyAccountAccessStatement).then( policy => {
              if ( newUser['policyId'] == undefined ) {
                let dataChanges = {
                  policyId: policy.policyId,
                }
                return this.adminService.updateUserByAccountIdWithoutSpinnerAndNotify( newUser.accountId, newUser.userId, dataChanges);
              }
              else
                return policy;
            }).catch(err => {
              console.log("Failed to add/update policy", err);
              throw err;
            });
          }
      });
    } else {
      return Promise.resolve(true);
    }
  }

  isButtonDisabled(user: User, product: ProductLicense, isSubComponent?: boolean): Promise<boolean> {
    this.initializeServices();
    if (isSubComponent) {
      return this.adminService.getAccountWithoutFrills(user.accountId, 'tags').then( newAccount => {

               //Checking if Account wide telephony disable policy is applied or not
               if ( newAccount['policyId'] === undefined )
                {
                  return false;
                }
                return this.adminService.getPolicy(newAccount.accountId, newAccount['policyId']).then( policy => {
                  console.log("Here are the account policies", policy);
                  const foundPolicy = policy.statements.find(stmt => {
                    return stmt.statementId === DisableTelephonyAccountAccessStatement.statementId;
                  });
                  if ( foundPolicy )
                  {
                    product.statusString = "product_licenses.account-wide-telephony-disable";
                    return true;
                  }
                  else
                    return false;
                });
      });
    }
    return Promise.resolve(false);
  }

  isProductEnabled(user: User, isSubComponent?: boolean): Promise<boolean> {
    this.initializeServices();
    if (isSubComponent) {
      if(!user['policyId']) {
        return Promise.resolve(true);
      }
      return this.adminService.getPolicy(user.accountId, user['policyId']).then( policy => {
          console.log("Here are the user policies", policy);
          const foundPolicy = policy.statements.find(stmt => {
            return stmt.statementId === DisableTelephonyAccountAccessStatement.statementId;
          });
          if ( foundPolicy )
          {
            return false;
          } else
            return true;
      });
    }
    return Promise.resolve(false);
  }
}
